// core/src/plugins/vant.ts
import { App } from 'vue'

// 按需导入组件（保持 tree-shakable）
import {
  // 基础组件
  Button,
  Cell,
  CellGroup,
  Icon,
  // 表单
  Field,
  Form,
  Radio,
  RadioGroup,
  Checkbox,
  // 反馈
  Toast,
  Dialog,
  Loading,
  ActionSheet,
  // 展示
  Image as VanImage,
  List,
  Skeleton,
  Stepper,
  Steps,
  Step,
  // 导航
  Tab,
  Tabs,
  Row,
  Col,
  // 选择器
  Picker,
  PickerGroup,
  TimePicker,
  DatePicker,
  Cascader,
  Popup,
  // 其他
  Search,
  Space,
  IndexBar,
  IndexAnchor
} from 'vant'

// 插件（非组件）
import { Lazyload } from 'vant'

// 样式（全局，无法按需）
import 'vant/lib/index.css'

// 所有要注册的组件列表
const components = [
  Button,
  Cell,
  CellGroup,
  Icon,
  Field,
  Form,
  Radio,
  RadioGroup,
  Checkbox,
  Toast,
  Dialog,
  Loading,
  ActionSheet,
  VanImage,
  List,
  Skeleton,
  Stepper,
  Steps,
  Step,
  Tab,
  Tabs,
  Row,
  Col,
  Picker,
  PickerGroup,
  TimePicker,
  DatePicker,
  Cascader,
  Popup,
  Search,
  Space,
  IndexAnchor,
  IndexBar
]

export const vantPlugins = {
  install(app: App) {
    // 注册所有组件
    components.forEach((component) => {
      app.use(component)
    })

    // 注册插件
    app.use(Lazyload, {
      lazyComponent: true
    })
  }
}

export default vantPlugins
